import { Revision, StoreRevisions } from "../types";
import { AllActions } from "../actions";

const initialState: StoreRevisions = {
  allIds: [],
  byId: {},
};

const getRevisionsSuccess = (revisions: Revision[]): StoreRevisions => {
  const storeRevisions = revisions.reduce<StoreRevisions>(
    ({ allIds, byId }, revision) => {
      return {
        allIds: [...allIds, revision.id],
        byId: {
          ...byId,
          [revision.id]: revision,
        },
      };
    },
    initialState
  );

  return storeRevisions;
};

const patchRevisionSuccess = (
  state: StoreRevisions,
  revisionId: string,
  isFavorite: boolean
): StoreRevisions => {
  return {
    ...state,
    byId: {
      ...state.byId,
      [revisionId]: { ...state.byId[revisionId], isFavorite },
    },
  };
};

const reducer = (state = initialState, action: AllActions) => {
  switch (action.type) {
    case "GET_REVISIONS_SUCCESS":
      return getRevisionsSuccess(action.revisions);

    case "PATCH_REVISION_START":
      return patchRevisionSuccess(state, action.revisionId, action.isFavorite);

    default:
      return state;
  }
};

export default reducer;
